module.exports = __webpack_public_path__ + "static/media/ioana_ursache.ca255ead.jpg";